var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"container-fluid py-6 py-md-7",attrs:{"id":"advisory-services"}},[_c('FAapproach'),_c('FAgallery'),_c('FAindustry'),_c('FAtransactions')],1)}
var staticRenderFns = []

export { render, staticRenderFns }